<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name 一般ユーザー
      slot(name="question")
    .register-value
      b-list-group.user-list(v-if="1 <= _value.length")
        b-list-group-item(v-for="checkbox in _value" style="padding: 0.25rem .5rem;")
          b-form-checkbox(:id="checkbox.id" v-model="checkbox.answer" :name="checkbox.id" :disabled="checkbox.disabled") {{ checkbox.name }}
      .warning-message(v-else)
        span 一般ユーザーが未登録です
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ShareStandardUserCheckBoxs extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: Array<ShareStandardUserCheckbox>;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): Array<ShareStandardUserCheckbox> {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: Array<ShareStandardUserCheckbox>) {
    this.$emit("input", newValue);
    return;
  }

  /** チェックボックスのクリックイベント */
  public onClick(): void {
    this.$emit("onClick");
  }
}

export interface ShareStandardUserCheckbox {
  /** ユーザーID */
  id: string;
  /** 回答 */
  answer: boolean;
  /** ユーザー名 */
  name: string;
  /** 非活性 */
  disabled: boolean;
}
</script>

<style lang="scss" scoped>
.user-list {
  position: relative;
  overflow-y: auto;

  width: 400px;
  max-height: 180px;
}
</style>
